import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Configura i18next
i18n
  .use(HttpApi) // per caricare i file di traduzione dal server
  .use(LanguageDetector) // per rilevare automaticamente la lingua
  .use(initReactI18next) // per l'integrazione con React
  .init({
    supportedLngs: ["en", "it"], // Lingue supportate
    fallbackLng: "it", // Lingua di fallback
    lng: "it", // Lingua di default: italiano
    detection: {
      order: ["cookie", "localStorage", "htmlTag", "navigator", "querystring"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Percorso dei file di traduzione
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
